// Toggle the nav bar on/off (only matters on mobile)
export const allCatsLoaded = response => ({
    type: "navigation/ALL_CATS_LOADED",
    payload: response
});
